import { useCallback } from 'react';
import type { FC } from 'react';
import icons from '@icons';
import { Picture } from '@ui';
import { twcls } from '@utils/twcls';
import { useLocalStorage } from '@utils/usehooks/useLocalStorage';
import { PRICE_CHANGE_WARNING_STORAGE_KEY } from '@constants/delivery';

const {
  alertCircle: { black: alertCircleBlack }
} = icons.Fill;

const {
  close: { darkGrey: closeDarkGrey }
} = icons.Outline;

interface PriceChangeWarningProps {
  className?: string;
  onDismiss?: () => void;
}

const PriceChangeWarning: FC<PriceChangeWarningProps> = ({
  className,
  onDismiss
}) => {
  const [isDismissed, setIsDismissed] = useLocalStorage(
    PRICE_CHANGE_WARNING_STORAGE_KEY,
    false
  );

  const dismissWarning = useCallback((): void => {
    setIsDismissed(true);
    onDismiss?.();
  }, [onDismiss, setIsDismissed]);

  if (isDismissed) {
    return null;
  }

  return (
    <div
      className={twcls(
        'flex w-full items-start bg-[#FEF7D0] px-3 py-2 text-sm font-normal leading-[18px]',
        className
      )}
    >
      <Picture
        className='mr-2.5 shrink-0'
        icon={alertCircleBlack}
        width='24'
        height='24'
        alt=''
      />
      <span className='flex-1 self-center'>
        Цены и ассортимент могут меняться в зависимости от адреса и способа получения
      </span>
      <button
        className='ml-3 flex h-5 w-5 shrink-0 cursor-pointer items-center justify-center border-0 bg-transparent p-0'
        type='button'
        aria-label='Закрыть предупреждение об изменении цен'
        onClick={dismissWarning}
      >
        <Picture icon={closeDarkGrey} width='20' height='20' alt='' />
      </button>
    </div>
  );
};

export default PriceChangeWarning;
